<template>
  <hel-module title="高风险供应商清单" :class="scope.clsPrefix" v-loading="loading">
    <template slot="extra">
      <button type="button" class="rl-all-link" @click="viewAllVisible = true">查看更多 ›</button>
    </template>

    <div class="rl-scroll">
      <table class="rl-table">
        <thead>
          <tr>
            <th class="rl-idx">序号</th>
            <th>供应商名称</th>
            <th>风险等级</th>
            <th>主要风险问题</th>
            <th>涉及物料</th>
            <th class="rl-amt">采购金额（万元）</th>
            <th>影响产品</th>
            <th>建议动作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in list" :key="row.idx">
            <td class="rl-idx">{{ row.idx }}</td>
            <td class="rl-sup">{{ row.name }}</td>
            <td><span class="rl-badge rl-hi">{{ row.level }}</span></td>
            <td>{{ row.problem }}</td>
            <td>{{ row.material }}</td>
            <td class="rl-amt">{{ row.amount }}</td>
            <td class="rl-prod">{{ row.products }}</td>
            <td>{{ row.action }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="!list.length" class="rl-empty">暂无数据</div>
    </div>

    <el-dialog
      :visible.sync="viewAllVisible"
      width="1120px"
      top="6vh"
      append-to-body
      :close-on-click-modal="false"
      custom-class="risk-all-dialog"
    >
      <div slot="title" class="rl-dialog-title">
        <div class="rl-dialog-title-main">高风险供应商清单 · 全部 {{ allList.length }} 家</div>
        <div class="rl-dialog-title-sub">
          风险等级取风险台账（fact_supplier_risk）原值，不由六因子推算；主要风险问题为台账六因子取值为「高」的维度、无高则退「中」，仅作待核线索；采购金额 = 本年度已下单合计；涉及物料 = 供应商主营类别；影响产品 = 供货物料经 BOM 反查。按本年度采购金额降序。
        </div>
      </div>
      <div class="rl-dialog-body">
        <table class="rl-table">
          <thead>
            <tr>
              <th class="rl-idx">序号</th>
              <th>供应商名称</th>
              <th>风险等级</th>
              <th>主要风险问题</th>
              <th>涉及物料</th>
              <th class="rl-amt">采购金额（万元）</th>
              <th>影响产品</th>
              <th>建议动作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in allList" :key="row.idx">
              <td class="rl-idx">{{ row.idx }}</td>
              <td class="rl-sup">{{ row.name }}</td>
              <td><span class="rl-badge rl-hi">{{ row.level }}</span></td>
              <td>{{ row.problem }}</td>
              <td>{{ row.material }}</td>
              <td class="rl-amt">{{ row.amount }}</td>
              <td class="rl-prod">{{ row.products }}</td>
              <td>{{ row.action }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </hel-module>
</template>

<script>
import HelModule from '../common/module/index.vue'
import { getHighRiskSuppliers } from '@/api/procurement'

const HIGH_RISK_LEVEL = '高风险'

export default {
  name: 'HighRiskSupplierList',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-high-risk-supplier-list'
      },
      list: [],
      allList: [],
      viewAllVisible: false
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const res = await getHighRiskSuppliers()
        if (!res || res.code !== 200 || !Array.isArray(res.data) || !res.data.length) {
          this.allList = []
          this.list = []
          return
        }
        const rows = res.data.map((row, index) => ({
          idx: index + 1,
          name: row.name,
          level: row.level || HIGH_RISK_LEVEL,
          problem: row.problem,
          material: row.material,
          amount: row.amount,
          products: row.products,
          action: row.action
        }))
        this.allList = rows
        // 卡片内只展示前 5 条，全部数据在「查看更多」弹框中查看
        this.list = rows.slice(0, 5)
      } catch (error) {
        console.error('获取高风险供应商清单数据失败:', error)
        this.allList = []
        this.list = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-high-risk-supplier-list";

// 表格样式写在顶层：弹框 append-to-body 后不在卡片根节点内，需保证样式同样生效
.rl-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;

  th,
  td {
    border: none;
    border-bottom: 1px solid #eef3fb;
    padding: 10px;
    text-align: left;
    color: #3d4a63;
    white-space: nowrap;
  }

  th {
    background: #eef3fb;
    color: #1f2a44;
    font-weight: 600;
    border-bottom: none;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .rl-idx {
    width: 48px;
    color: #8aa0c0;
  }

  .rl-sup {
    color: #1f2a44;
    font-weight: 600;
  }

  .rl-amt {
    color: #1f2a44;
    font-weight: 700;
    text-align: center;
  }

  .rl-prod {
    color: #5a6b88;
    white-space: normal;
    max-width: 260px;
  }
}

.rl-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  white-space: nowrap;
}

.rl-hi {
  background: #fdecec;
  color: #d64545;
}

.rl-empty {
  padding: 16px 4px;
  font-size: 12px;
  color: #98a1b2;
}

// 弹框标题
.rl-dialog-title {
  .rl-dialog-title-main {
    font-size: 15px;
    font-weight: 700;
    color: #1f2329;
  }

  .rl-dialog-title-sub {
    margin-top: 4px;
    font-size: 11.5px;
    font-weight: normal;
    color: #6b7f9a;
    line-height: 1.5;
  }
}

// 弹框内影响产品列可放宽（弹框更宽）
.rl-dialog-body .rl-table .rl-prod {
  max-width: 430px;
}

.#{$class-prefix} {
  .rl-all-link {
    padding: 0;
    border: none;
    background: none;
    font-family: inherit;
    font-size: 12px;
    color: #4a5ff3;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .rl-scroll {
    height: 100%;
    overflow: auto;
  }
}
</style>

<!-- 全局样式：el-dialog append-to-body 后 scoped 不作用于 dialog 容器，需用全局样式 -->
<style lang="scss">
.risk-all-dialog {
  margin-top: 6vh !important;
  margin-bottom: 6vh !important;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 12vh);

  .el-dialog__header {
    flex-shrink: 0;
    padding: 16px 20px 10px;
    border-bottom: 1px solid #f0f0f0;
  }

  .el-dialog__body {
    flex: 1;
    overflow: auto;
    min-height: 0;
    padding: 16px 20px 18px;
  }
}
</style>
